'use strict';

import globalize from './internal/globalize';

var version = '7.8.1';

globalize('version', version);

export default version;
